import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cd7a014"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-citations-module-head" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.citationsType, (citation, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        onClick: ($event: any) => (_ctx.callbackFn(citation)),
        class: _normalizeClass([
				'hd-citations-module-head__item',
				{ 'is-active': _ctx.activeCitationType === citation },
				'crux-click'
			]),
        "data-crux": "citations-tab"
      }, _toDisplayString(citation), 11, _hoisted_2))
    }), 128))
  ]))
}